module.exports = __webpack_public_path__ + "img/21.7f524a56.jpg";